import { useState, useEffect } from 'react';

function useAdBlockerDetected() {
  const [adBlockerDetected, setAdBlockerDetected] = useState(false);

  useEffect(() => {
    const detected = () => setAdBlockerDetected(true);
    const notDetected = () => setAdBlockerDetected(false);

    const script = document.createElement('script');
    script.onload = () => {
      window.fuckAdBlock.onDetected(detected);
      window.fuckAdBlock.onNotDetected(notDetected);
    };
    script.onerror = detected;
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/fuckadblock/3.2.1/fuckadblock.min.js';
    script.integrity = 'sha256-xjwKUY/NgkPjZZBOtOxRYtK20GaqTwUCf7WYCJ1z69w=';
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }, []);

  return adBlockerDetected;
}

export default useAdBlockerDetected;
